import TableHeader from './TableHeader'

export default TableHeader



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/Crpcomponents/TableHeader/index.js